import {Box, Flex, Text} from '@chakra-ui/react'
import BannerRevise from '@assets/images/learn/notebook_banner.png'

const Header = ({folders}: {folders: any}) => {
  return (
    <Box
      minH={'400px'}
      bgImage={BannerRevise}
      bgRepeat={'no-repeat'}
      bgSize={'cover'}
      borderRadius={'0px 0px 100px 100px'}>
      <Flex
        flexDirection={{base: 'column', md: 'row'}}
        justifyContent={'space-between'}
        pt={{base: '32px', md: '54px'}}
        gap={'16px'}
        maxW={'1280px'}
        mx={'auto'}
        px={{base: '24px', md: '70px'}}>
        <Flex
          flexDirection={'column'}
          textAlign={{base: 'center', md: 'unset'}}
          color={'#002766'}>
          <Text fontSize={{base: '14px', md: '16px'}}>
            Theo mức độ ghi nhớ của bạn ...
          </Text>
          <Text fontSize={{base: '18px', md: '24px'}} fontWeight={600}>
            {`Có ${folders && (folders?.sentence_quantity || 0)} mẫu câu của ${folders && (folders?.topic_quantity || 0)} chủ đề cần ôn hôm nay`}
          </Text>
          <Text fontSize={{base: '14px', md: '16px'}} mt={'24px'}>
            Hãy chọn chủ đề và bấm Bắt đầu khi sẵn sàng nhé!
          </Text>
        </Flex>
      </Flex>
    </Box>
  )
}

export default Header
